import { useEffect } from 'react';

import { useEnvironment } from '@wix/yoshi-flow-editor';

import {
  expandWidget,
  oneChatSettingsModel,
  selectOneChatSettings,
  selectOneChatComposed,
} from '@/features';
import { useAppDispatch, useAppSelector } from '@/store';
import { SS_FORCE_EXPAND_IN_VIEWER } from '@/constants';

const { Appearance } = oneChatSettingsModel;

export const useForcedExpandInViewer = () => {
  const dispatch = useAppDispatch();
  const { isEditor, isMobile } = useEnvironment();

  const neverLoadedSettings = useAppSelector(selectOneChatSettings.neverLoaded);

  const shouldAutoOpenWidget = useAppSelector(
    selectOneChatComposed.shouldAutoOpenWidget,
  );
  const appearance = useAppSelector(selectOneChatSettings.appearance);
  const appearanceIncludesMobile =
    appearance === Appearance.MOBILE ||
    appearance === Appearance.DESKTOP_AND_MOBILE;

  useEffect(() => {
    if (isEditor || neverLoadedSettings) {
      return;
    }

    if (!shouldAutoOpenWidget) {
      return;
    }

    if (isMobile) {
      if (!appearanceIncludesMobile) {
        return;
      }
    }

    if (
      JSON.parse(sessionStorage.getItem(SS_FORCE_EXPAND_IN_VIEWER) ?? 'false')
    ) {
      return;
    }

    dispatch(expandWidget());
    sessionStorage.setItem(SS_FORCE_EXPAND_IN_VIEWER, 'true');
  }, [
    isEditor,
    neverLoadedSettings,
    shouldAutoOpenWidget,
    isMobile,
    appearanceIncludesMobile,
    dispatch,
  ]);
};
